import React from "react";
import "../SignIn/SignIn.css";
import "../ForgotPassword/ForgotPassword.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../assets/communityXlogo.svg";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import forgot from "../../assets/forgot.png";
import { MdArrowBack } from "react-icons/md";
import { useState } from "react";
import {
  EmailCheck,
  MobileNumberCheck,
} from "../../ConditionChecks/ConditionChecks";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { Forgotpassword } from "../../Utils/Api/Forgotpassword";
import Loader from "../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { useDispatch } from "react-redux";
import { getOTPCounterTime } from "../../redux/OTPCounterSlice";
import { getResendCode } from "../../redux/ResendCodeSlice";

const ForgotPassword = () => {
  const [emailcheck, setEmailCheck] = useState("on");
  const [mobileCheck, setMobileCheck] = useState("");
  const [checked, setChecked] = useState(true);
  const [loading, setLoading] = useState(false);

  const [phone, setPhone] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [commonErr, setCommonErr] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formatPhoneNumber = (value) => {
    let digits = value.replace(/\D/g, "");
    digits = digits.substring(0, 10);
    let formatted = digits;
    if (digits.length > 3) {
      formatted = digits.substring(0, 3) + "-" + digits.substring(3);
    }
    if (digits.length > 6) {
      formatted = formatted.substring(0, 7) + "-" + formatted.substring(7);
    }

    return formatted;
  };

  const validatePhoneNumber = (value) => {
    let digits = value.replace(/\D/g, "");
    return digits.length === 10;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e, field) => {
    setCommonErr("");
    let value = e.target.value;
    if (field === "email") {
      setEmail(value);
      if (!validateEmail(value)) {
        setEmailErr("Please enter a valid email address!");
      } else {
        setEmailErr("");
      }
    } else if (field === "mobile") {
      let formattedValue = formatPhoneNumber(value);
      setPhone(formattedValue);
      if (!validatePhoneNumber(formattedValue)) {
        setPhoneErr("Please enter a valid mobile number!");
      } else {
        setPhoneErr("");
      }
    }
  };

  const onEmailCheck = (e) => {
    setEmailCheck(e.target.value);
    setMobileCheck("");
    setPhone("");
    setChecked(!checked);
    setCommonErr("");
  };

  const onMobileCheck = (e) => {
    setMobileCheck(e.target.value);
    setEmailCheck("");
    setEmail("");
    setCommonErr("");
  };

  const ForgotPasswordHandler = async (ForgotPsswordCredentials) => {
    setLoading(true);
    const forgotpassword = await Forgotpassword(
      ForgotPsswordCredentials,
      () => {
        navigate("/");
      }
    );
    if (forgotpassword === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (forgotpassword.success === true) {
        toast.success(forgotpassword.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        dispatch(getResendCode(ForgotPsswordCredentials));
        dispatch(getOTPCounterTime(forgotpassword.timer));
        navigate("/otp", { state: { data: forgotpassword } });
        setLoading(false);
      }
      if (forgotpassword.success === false) {
        toast.error(forgotpassword.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  const SubmitHandler = (e) => {
    e.preventDefault();

    const isEmailChecked = emailcheck === "on";
    const input = isEmailChecked ? email : phone;
    const inputErr = isEmailChecked ? emailErr : phoneErr;
    const emptyInputMessage = isEmailChecked
      ? "Please enter email address!"
      : "Please enter mobile number!";
    const checkValue = isEmailChecked ? 1 : 2;
    const formattedInput = isEmailChecked ? email : phone.replace(/-/g, "");

    if (input.length === 0) {
      setCommonErr(emptyInputMessage);
    } else if (commonErr === "" && inputErr === "") {
      let ForgetPassword_API_Details = {
        check: checkValue,
        forgot_pwd_input: isEmailChecked ? input : parseInt(formattedInput),
      };
      ForgotPasswordHandler(ForgetPassword_API_Details);
    } else {
      console.log("not filled");
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image
                loading="lazy"
                src={forgot}
                className="my-5 py-5 imgwidth-100"
              ></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2 mt-5">
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <p className="sign-second mt-2 pt-2">Forgot Password</p>
              </div>
              <Row>
                <div className="signemail mt-3 pb-2 formmain signin-row">
                  <p className="text-center recive-text">
                    Recieve a verification Code
                  </p>
                  <Form onSubmit={SubmitHandler} className="passwordcheck mt-4">
                    <div
                      className={
                        emailcheck === "on" ? "emailcheckTrue" : "emailcheck"
                      }
                    >
                      <Form.Check
                        name="grouped"
                        required
                        inline
                        type="radio"
                        className={checked === true ? "checked-radio" : ""}
                        isValid
                        defaultChecked={true}
                        onChange={onEmailCheck}
                      />
                      Via Registered Email Address
                    </div>
                    <p className="loginwith pt-3">
                      <span>Or</span>
                    </p>
                    <div
                      className={
                        emailcheck !== "on" ? "emailcheckTrue" : "emailcheck"
                      }
                    >
                      <Form.Check
                        className={checked === true ? "checked-radio" : ""}
                        name="grouped"
                        required
                        inline
                        type="radio"
                        isValid
                        onChange={onMobileCheck}
                      />
                      Via Registered Mobile number
                    </div>
                    <Form.Group className="mt-4" controlId="formBasicEmail">
                      {emailcheck === "on" ? (
                        <>
                          <Form.Label className="form-label-custom">
                            <div className="label-info-text">
                              Email Address{" "}
                              <span className="star-required">*</span>
                            </div>
                          </Form.Label>{" "}
                          <Form.Control
                            type="email"
                            placeholder="Enter Email Address"
                            className="custom-formcontrol"
                            onChange={(e) => handleChange(e, "email")}
                            value={email}
                            maxLength={70}
                            autoComplete="off"
                          />
                          {emailErr && email.length !== 0 && (
                            <div style={{ color: "red" }}>{emailErr}</div>
                          )}
                        </>
                      ) : (
                        <>
                          <Form.Label className="form-label-custom">
                            <div className="label-info-text">
                              Mobile Number{" "}
                              <span className="star-required">*</span>
                              <p className="info-text-space">
                                &#40;Numbers only. No dash (-) or dot(.) between
                                numbers&#41;
                              </p>
                            </div>
                          </Form.Label>
                          <div className="mobile_Number_Forgot">
                            <Form.Control
                              value="+1"
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              disabled={true}
                              className="mobile_Input"
                              autoComplete="off"
                            />
                            <Form.Control
                              type="text"
                              value={phone}
                              onChange={(e) => handleChange(e, "mobile")}
                              placeholder="Enter Mobile Number"
                              className="custom-formcontrol flex-1"
                              autoComplete="off"
                            />
                          </div>
                          {phoneErr && (
                            <div style={{ color: "red", fontSize: 13 }}>
                              {phoneErr}
                            </div>
                          )}
                        </>
                      )}
                      {commonErr && (
                        <div style={{ color: "red", fontSize: 13 }}>
                          {commonErr}
                        </div>
                      )}
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-2"
                    >
                      Send
                    </Button>
                  </Form>
                </div>
                <Link to="/">
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ForgotPassword;
